import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import {
  normalizeCertificationDealers,
  createCertificationSlotInput,
} from '@/helpers/certification/certificationTermsFormLogic'

dayjs.extend(customParseFormat)

const API_DATETIME = 'YYYY-MM-DD HH:mm'

function parseApiDateTime(value) {
  return dayjs(value, API_DATETIME)
}

/**
 * Mapuje odpowiedź GET /certifications/{id} na model formularza edycji.
 */
// eslint-disable-next-line import/prefer-default-export
export function mapCertificationApiToFormData(apiData) {
  const data = { ...apiData }
  data.examiner = data.examiner ? data.examiner['@id'] : null
  data.dealers = normalizeCertificationDealers(data.dealers || [])
  data.informationMaterials = data.informationMaterials || []
  data.reportMaterials = data.reportMaterials || []

  data.slotTimeInputs = (data.slots || []).map(slot => {
    const time = parseApiDateTime(slot.time).format('HH:mm')
    return createCertificationSlotInput(time, slot.enrolmentId ?? null)
  })
  data.date = data.date ? parseApiDateTime(data.date).format('YYYY-MM-DD') : null

  return data
}
